import { render } from "./ImportantLinksServiceParameter.vue?vue&type=template&id=1f291c06"
import script from "./ImportantLinksServiceParameter.vue?vue&type=script&lang=ts"
export * from "./ImportantLinksServiceParameter.vue?vue&type=script&lang=ts"
script.render = render

export default script